"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Currencies = Object.freeze({
  BMAR: {
    symbol: '$',
    thousandsSeparatorSymbol: '.',
    decimalSeparatorSymbol: ','
  },
  BMCL: {
    symbol: '$',
    thousandsSeparatorSymbol: '.',
    decimalSeparatorSymbol: ','
  },
  BMEC: {
    symbol: '$',
    thousandsSeparatorSymbol: '.',
    decimalSeparatorSymbol: ','
  },
  BMMX: {
    symbol: '$',
    thousandsSeparatorSymbol: ',',
    decimalSeparatorSymbol: '.'
  },
  BMPA: {
    symbol: 'B/.',
    thousandsSeparatorSymbol: ',',
    decimalSeparatorSymbol: '.'
  },
  BMPE: {
    symbol: 'S/.',
    thousandsSeparatorSymbol: ',',
    decimalSeparatorSymbol: '.'
  },
  BMVE: {
    symbol: 'Bs.',
    thousandsSeparatorSymbol: '.',
    decimalSeparatorSymbol: ','
  },
  ZJAR: {
    symbol: '$',
    thousandsSeparatorSymbol: '.',
    decimalSeparatorSymbol: ','
  }
});